require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ipsa-omnis-occaecati-molestiae-doloribus-occaecati-incidunt.json") })
        }
      }, "path---ipsa-omnis-occaecati-molestiae-doloribus-occaecati-incidunt");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ipsa-omnis-occaecati-molestiae-doloribus-occaecati-incidunt!./.cache/json/ipsa-omnis-occaecati-molestiae-doloribus-occaecati-incidunt.json
// module id = 397
// module chunks = 231608221292675